import { Injectable } from '@angular/core';
import { CreatePrompt, Prompt, PromptModel } from '../models/prompt.model';
import { CreatePromptVersion } from '../models/prompt-version.model';
import {Observable, of, switchMap} from 'rxjs';
import { OrganizationEntityApiService } from './organization-entity-api.service';
import {producerMarkClean} from '@angular/core/primitives/signals';

/**
 * Service for managing prompts within organizations.
 * All operations are scoped to organizations and default to the active organization.
 */
@Injectable({
  providedIn: 'root'
})
export class PromptsService extends OrganizationEntityApiService<Prompt, PromptModel, CreatePrompt> {
  constructor() {
    // Prompts are scoped to organizations
    // Routes: /organizations/:orgId/prompts
    super(PromptModel, 'prompts', 'organizations');
  }

  /**
   * Create a new version of a prompt. Defaults to active organization if no orgId provided.
   * @param prompt - Prompt
   * @param request - Version request (only when orgId is provided)
   */
  createVersion(prompt: PromptModel, request: CreatePromptVersion): Observable<PromptModel> {
    return this.mapper.map(this.withOrgId(
      (orgId: string) => this.post<Prompt>(`organizations/${orgId}/prompts/${prompt.id}/versions`, request)
    ))
  }
}
